<app-navbar-style-one></app-navbar-style-one>

    <section class="values-section position-relative">
        <div class="decorative-icon icon-garlic">🧄</div>
        <div class="decorative-icon icon-cheese">🧀</div>
        <div class="container">
            <h2>Our Values</h2>
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="value-card">
                        <p class="value-paragraph">Bringing our neighborhood together one slice at a time, and treating every guest like family.</p>
                        <div class="value-icon">
                            <i class="bx bx-home"></i>
                        </div>
                        <p class="value-title">Community & Care</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="value-card">
                        <p class="value-paragraph">Committed to eco-friendly packaging and responsibly sourced fresh ingredients for a greener tomorrow.</p>
                        <div class="value-icon">
                            <i class="bx bx-home"></i>
                        </div>
                        <p class="value-title">Sustainability</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="value-card">
                        <p class="value-paragraph">Our expert chefs pour their love and genuine dedication into every hand-tossed pizza we bake.</p>
                        <div class="value-icon">
                            <i class="bx bx-home"></i>
                        </div>
                        <p class="value-title">Team Passion</p>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="value-card">
                        <p class="value-paragraph">Going the extra mile to ensure every hot, crispy bite brings a happy smile to your face.</p>
                        <div class="value-icon">
                            <i class="bx bx-home"></i>
                        </div>
                        <p class="value-title">Customer Delight</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Why Dine Section -->
    <section class="why-dine-section">
        <div class="container">
            <h2>Why Dine With Us</h2>
            <p>Many ask!</p>
        </div>
    </section>

    <!-- Build Your Own Section -->
    <section class="build-section">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-3 col-md-4 text-center mb-4 mb-md-0" style="border-radius: 0 200px 200px 0;background-color: #E2E4FE;">
                    <img src="../../../../assets/img/home2/about-left.png" alt="Pizza" class="food-image1">
                </div>
                <div class="col-lg-6 col-md-4">
                    <div class="build-content">
                        <h3>Build Your Own</h3>
                        <!-- <p>Your flavor, your choice! Build your own pizza or burger just the way you love it. From crispy crusts to bold toppings, you’re in control — let’s make something amazing together.</p> -->
                        <a href="custom-food" class="start-btn">Start Now</a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 text-center" style="border-radius: 200px 0 0 200px;background-color: #FFE7E7;">
                    <img src="../../../../assets/img/home2/about-right.png" alt="Burger" class="food-image2">
                </div>
            </div>
        </div>
    </section>

    <!-- Our Story Section -->
    <section class="story-section">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-md-4 mb-4">
                    <div class="feature-box text-center">
                        <img src="../../../assets/img/home2/analysis.png" alt="Pizza" class="feature-box-image">
                        <p class="m-auto">Explore our delicious, hand-crafted menu.</p>
                    </div>
                    <div class="feature-box text-center">
                        <img src="../../../assets/img/home2/fish.png" alt="Pizza" class="feature-box-image">
                        <p class="m-auto">Catch our premium daily specials.</p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="story-card">
                        <h3>Our Story</h3>
                        <p>{{aboutContent}}</p>
                        <img src="{{aboutImage}}" alt="Chef" class="story-image">
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="feature-box text-center">
                        <img src="../../../assets/img/home2/smile.png" alt="Pizza" class="feature-box-image">
                        <p class="m-auto">Bringing joy in every single slice.</p>
                    </div>
                    <div class="feature-box text-center">
                        <img src="../../../assets/img/home2/spirit.png" alt="Pizza" class="feature-box-image">
                        <p class="m-auto">Fired up with true Italian passion.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Service Section -->
    <section class="service-section">
        <div class="service-content">
            <div class="container">
                <h2>We’re committed to great service <br>— feel free to reach out anytime.</h2>
                <div class="working-hours-section">
                    <div class="row mx-4">
                        <div class="col-md-12">
                            <span class="openingHoursTitle">Opening Hours</span>
                        </div>
                        <div class="col-md-12">
                            <p class="openingHours">"{{working_hours || ''}}"</p>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-4 mb-4">
                        <div class="service-card">
                            <div class="service-icon">
                                <i class="bx bxs-map"></i>
                            </div>
                            <p>{{address}}</p>
                        </div>
                    </div>
                    <div class="col-md-4 mb-4">
                        <div class="service-card">
                            <div class="service-icon">
                                <i class="bx bxs-phone"></i>
                            </div>
                            <p><a href="tel:{{phone}}">{{phone}}</a></p>
                        </div>
                    </div>
                    <div class="col-md-4 mb-4">
                        <div class="service-card">
                            <div class="service-icon">
                                <i class="bx bxs-envelope"></i>
                            </div>
                            <p><a href="mailto:{{email}}">{{email}}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


<app-footer-style-two></app-footer-style-two>